import { AsyncScheduler } from './AsyncScheduler';

export class QueueScheduler extends AsyncScheduler {
}



// WEBPACK FOOTER //
// ../../src/scheduler/QueueScheduler.ts